import React from 'react';

const ResultMessage = ({result}) => {
    if (!result) {
        return null;
    }

    const {success, message} = result;

    const textClass = success ? 'success' : 'danger';
    const icon = success ? 'check' : 'times';

    return (
        <div className="form-group">
            <p className={`form-control-static text-bold text-${textClass}`}>
                <i className={`fa fa-fw fa-${icon}`}></i>
                {message}
            </p>
        </div>
    );
}

export default ResultMessage;